<template>
  <q-modal
      :value="opened"
      @close="close()"
      @escape-key="close()"
      @hide="close()"
  >
    <div class="q-pa-lg">
      <q-datetime
          v-model="createdAt"
          type="datetime"
          clearable
          stack-label="Дата подписания договора"
      />

      <div class="row justify-end q-mt-md">
        <q-btn
            @click="generate"
            color="primary"
            flat
            class="q-ml-sm"
            label="Сгенерировать"
        />

        <q-btn
            @click="close()"
            color="primary"
            flat
            class="q-ml-sm"
            label="Отмена"
        />
      </div>
    </div>
  </q-modal>
</template>

<script>
import {
  QBtn,
  QField,
  QDatetime,
  QInput,
  QModal,
  QInnerLoading,
  QSpinner
} from 'quasar';

export default {
  name: "CreateDocumentModal",

  components: {
    QInput,
    QBtn,
    QField,
    QDatetime,
    QModal,
    QInnerLoading,
    QSpinner
  },

  props: {
    opened: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      createdAt: null,
    }
  },

  methods: {
    close() {
      this.$emit('closed')
    },

    generate() {
      this.$store.dispatch('project/generateLicenseWithContract', {
        projectId: this.$route.params.id,
        createdAt: this.createdAt,
      }).then((data) => {
        if (data[0].errors) {
          data[0].errors.forEach((error) => {
            this.$q.notify({
              color: 'negative',
              message: error,
              timeout: 3000,
            })
          })

          return
        }

        this.$q.notify({
          message: 'Документ успешно создан',
          type: 'positive',
        })

        this.close()
      })
    },
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ProjectDocuments/CreateDocumentModal.vue